const listeners = new Map();
let messageId = 1000;

class MockWebSocket {
  constructor() {
    this.connected = true;
    this.onMessage = null;
  }

  send(data) {
    const parsed = JSON.parse(data);

    if (parsed.type === 'message') {
      setTimeout(() => {
        if (this.onMessage) {
          this.onMessage({
            id: ++messageId,
            ...parsed.payload,
            timestamp: Date.now(),
            status: 'delivered',
          });
        }
      }, 100);

      setTimeout(() => {
        if (this.onMessage) {
          this.onMessage({
            type: 'read_receipt',
            messageId: parsed.payload.id,
            readAt: Date.now(),
          });
        }
      }, 2000);
    }

    if (parsed.type === 'recall') {
      setTimeout(() => {
        if (this.onMessage) {
          this.onMessage({
            type: 'message_recalled',
            messageId: parsed.payload.messageId,
          });
        }
      }, 100);
    }
  }

  subscribe(event, callback) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(callback);
    return () => listeners.get(event)?.delete(callback);
  }

  emit(event, data) {
    listeners.get(event)?.forEach((cb) => cb(data));
  }

  close() {
    this.connected = false;
    listeners.clear();
  }
}

let instance = null;

export function getWebSocket() {
  if (!instance) instance = new MockWebSocket();
  return instance;
}
